import apiClient from './apiClient';

export type BugReportStatus = 'new' | 'in_progress' | 'resolved' | 'closed' | 'wontfix';
export type BugReportPriority = 'low' | 'medium' | 'high' | 'critical';

export interface BugReportUser {
  id: string;
  name: string;
  email: string;
  phone_number: string;
  user_type: string;
}

export interface BugReport {
  id: string;
  title: string;
  description: string;
  email: string;
  status: BugReportStatus;
  priority: BugReportPriority;
  app_version: string;
  device_info: string;
  user: BugReportUser | null;
  created_at: string;
  updated_at: string;
  resolved_at: string | null;
  comments_count: number;
}

export interface BugReportListResponse {
  count: number;
  page: number;
  page_size: number;
  results: BugReport[];
  summary: {
    new: number;
    in_progress: number;
    resolved: number;
    closed: number;
  };
}

export interface BugReportFilters {
  status?: string;
  priority?: string;
  search?: string;
  page?: number;
  page_size?: number;
}

class BugReportService {
  async getBugReports(filters: BugReportFilters = {}): Promise<BugReportListResponse> {
    const response = await apiClient.get('/admin/bug-reports/', { params: filters });
    return response.data.data;
  }

  async updateBugReport(
    reportId: string,
    data: Partial<Pick<BugReport, 'status' | 'priority'>>
  ): Promise<BugReport> {
    const response = await apiClient.patch(`/admin/bug-reports/${reportId}/`, data);
    return response.data.data;
  }
}

const bugReportService = new BugReportService();

export default bugReportService;
